import { useDispatch } from 'react-redux'

export const useAppDispatch = useDispatch
